import {useEffect, useState} from 'react';
import {initializeFirebase} from '../database/configure';

import {collection, doc, getDocs, getFirestore, onSnapshot, setDoc} from 'firebase/firestore';
import Button from '@mui/material/Button';

// const docData = {
//     stringExample: 'Hello world!',
//     booleanExample: true,
//     numberExample: 3.14159265,
//     dateExample: Timestamp.fromDate(new Date('December 10, 2023')),
//     arrayExample: [5, true, 'hello'],
//     nullExample: null,
//     objectExample: {
//         a: 5,
//         b: {
//             nested: 'foo'
//         }
//     }
// };
const docData = (questionId) => {
  return {
    question: questionId,
    voteCount: Math.round(Math.random() * 100)
  };
}

const likedBy = (userCount, poll_id) => {
  const answeredBy = []
  for (let i = 0; i <= userCount; i++) {
    answeredBy.push(`user_${i}`)
  }

  const answeredByUniq = [...new Set(answeredBy)]
  return {
    answeredBy: answeredByUniq,
    answeredByCount: answeredByUniq.length,
    poll_id: poll_id
  }
}


export default function FirebasePage() {
  const [fApp, setFApp] = useState(null)
  // const [db, setDb] = useState(null)

  // if (fApp) {
  //     setDb(getFirestore(fApp));
  // }

  const addData = async (db) => {
    const rootCollectionName = 'new_polls_aravind'
    const startId = 0
    const endId = startId + 3
    for (let i = startId; i < endId; i++) {
      const pollId = `poll_id_${i}`
      await setDoc(doc(db, rootCollectionName, pollId), docData(pollId));
      await setDoc(doc(db, `${rootCollectionName}/${pollId}/subCollAnsweredBy`,
        'subCollDocAnsweredBy'), likedBy(Math.round(Math.random() * 10), pollId));
    }
  }

  const handleAddData = async () => {
    if (fApp) {
      const db = getFirestore(fApp)
      addData(db).then((sucRes) => {
        console.log(sucRes)
      }).catch((er) => {
        console.log(er)
      })
    }
  }


  const readDataAsync = async () => {
    const db = getFirestore(fApp)
    const querySnapshot = await getDocs(collection(db, 'test_polls_aravind'));
    querySnapshot.forEach((doc) => {
      console.log('querySnapshot loop')
      console.log(`${doc.id} => ${JSON.stringify(doc.data())}`);
    });
  }

  const handleReadData = () => {
    readDataAsync()
  }

  const handleRealtimeUpdates = () => {
    const db = getFirestore(fApp)
    onSnapshot(doc(db, 'test_collection/alovelace'), (doc) => {
      console.log('Current data: ', doc.data());
    });
  }

  useEffect(() => {
    setFApp(initializeFirebase())
  }, [])

  return <>FirebasePage
    <Button onClick={handleAddData}>Add Data</Button>
    <Button onClick={handleReadData}>Read Data</Button>
    <Button onClick={handleRealtimeUpdates}>Get Real time Updates</Button>
  </>
}
